import { render, staticRenderFns } from "./Clutch.vue?vue&type=template&id=68f1f636&scoped=true"
import script from "./Clutch.vue?vue&type=script&lang=js"
export * from "./Clutch.vue?vue&type=script&lang=js"
import style0 from "./Clutch.vue?vue&type=style&index=0&id=68f1f636&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "68f1f636",
  null
  
)

export default component.exports